<template>
  <MDBFooter bg="light" :text="['center', '#394275']">

    <div v-html="post?.content?.rendered"></div>

</MDBFooter>

</template>

<script src="./_AppFooter.js" lang="js"></script>
<style src="./_AppFooter.less" lang="less" scoped></style>
